import { Injectable } from '@angular/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { AuthenticationService } from '@bo-client/core';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { TenantDto } from '@bo-client/shared/models/tenantDto';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { UploadTypeEnum } from '@bo-client/shared/components/upload-documents/upload-documents.enum';
import { ErrorFormCommissioningEnum } from '@bo-client/activation-management/shared/forms/create-forms-errors-model';
import { ErrorsFormsService } from '@bo-client/shared/form-errors/errors-forms.service';

@Injectable()
export abstract class ConfirmationRequestFormBase<T> {
  protected constructor(
    protected authenticationService: AuthenticationService,
    protected dataShareService: DataShareService,
    protected errorsFormsService: ErrorsFormsService
  ) {}

  compUnsubs$ = new Subject<void>();

  public errorFormList: ShowErrorModel[] = [];
  public formGroup: FormGroup;
  public selectedTenant: TenantDto;

  loadData() {
    this.selectedTenant = this.dataShareService.selectedTenant;
  }

  public getFormGroup() {
    return this.formGroup;
  }

  public isValid() {
    this.detectFormChanges();
    this.loadErrorsList();
    return this.errorFormList.length == 0;
  }

  detectFormChanges() {
    this.formGroup.valueChanges
      .pipe(takeUntil(this.compUnsubs$), debounceTime(100), distinctUntilChanged())
      .subscribe(() => {
        this.loadErrorsList();
      });
  }

  uploadDocument(event: UploadTypeEnum) {
    if (event == UploadTypeEnum.uploadAfterDisable) {
      // TODO this.onSubmit('save')
    }
  }

  loadErrorsList() {
    this.errorFormList = this.errorsFormsService.checkTwoLevelFormErrors(
      this.formGroup,
      ErrorFormCommissioningEnum,
      null
    );
    this.hookErrors();
  }

  protected hookErrors() {}

  abstract loadFormWithModel(result: T);
}
